module.exports = new __parcel__URL__("light.936b96f7.svg").toString();